import { useTable, useSortBy, usePagination } from "react-table";
import { Link, useHistory } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useReactToPrint } from "react-to-print";
import { Store, ReactNotifications } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import imagenProfile from "../../assets/img/user/user-13.jpg";
import { Tabs, Tab } from "react-tabs-scrollable";
import "react-tabs-scrollable/dist/rts.css";
import { AppSettings } from "./../../config/app-settings";
import 'moment/locale/es';
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../components/panel/panel.jsx";
import Moment from "moment";
import { useDispatch, useSelector ,shallowEqual} from "react-redux";
import CreatableSelect from "react-select/creatable";
import React, { useState, useEffect, useRef, useContext } from "react";
import {
  addFilesOpen,
  getEntities,
  getFiles,
  getFilesFromUrl,
  getFilesSearch,
  getPersonsAssignments,
  getPersonsCustomer,
  getUsers,
  removeFilesOpen
} from "../../actions/index.js";

import { useDownloadExcel } from "react-export-table-to-excel";
import { Modal, ModalHeader, ModalBody, ModalFooter, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown } from "reactstrap";
import Tooltip from "rc-tooltip";
import {
  canAssignExpediente,
  classesStatus,
  CopyRight,
  formatExpedienteDate,
  AxiosURLImage,
  instance,
  optionsStatus,
  status,
  successPermissions,
  useCompareId,
} from "../../utils/index.js";
import Select from "react-select";
import DateRangePicker from "react-bootstrap-daterangepicker";
const Expedientes = (props) => {
  const tableRef = useRef(null);
  const context = useContext(AppSettings);
  const history = useHistory();
  const [timer, setTimer] = useState(null);
  const [modalDialog, setmodalDialog] = useState(false);
  const [modalAsignment, setmodalAsignment] = useState(false);
  const [isAssigning, setIsAssigning] = useState(false);
  const [PersonaAsignar, setPersonaAsignar] = useState("");
  const [modalDialogFileCreate, setmodalDialogFileCreate] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const [serverPageSize, setServerPageSize] = useState(10);
  const [serverOrdering, setServerOrdering] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoadingList, setIsLoadingList] = useState(true);
  const [ComentarioAsignar, setComentarioAsignar] = useState("");
  const [IdSelected, setIdSelected] = useState(null);
  const [reasons, setreasons] = useState(null);
  const [value_reason, setvalue_reason] = useState("");
  const [initialPageIndex, setinitialPageIndex] = useState(0);
  const [modalDialogAlert, setmodalDialogAlert] = useState(false);
  const [modalDialogAlertError, setmodalDialogAlertError] = useState(null);
  const [preloadedFreelancers, setPreloadedFreelancers] = useState([]);
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Expedientes table",
    sheet: "Expedientes",
  });
  const [inputs, setInputs] = useState({
    open_date: Moment().format("YYYY-MM-DD"),
    startDate: Moment().subtract(7, "days"),
    endDate: Moment(),
    isLoading: false,
    isLoadingBen: false,
    isLoadingCausante: false,
    isLoadingFree: false,
    isLoadingBy: false,
    beneficiaries: [],
    inputFreelance: "",
    textSearch: "",
    entityDefault: false,
    closeFilters: false,
    freelanceOnly: false,
  });

  useEffect(() => {
    if (
      context &&
      localStorage.email &&
      localStorage.email.includes("siep.com.co")
    ) {
      context.handleSetActualizarEmail();
    }

    // context.handleSetAppContentClass("p-0");
    // return () => {
    //   context.handleSetAppContentClass(false);
    // };
  }, []);

  const toDay = Moment().format("YYYY-MM-DD");
  var handleChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    setInputs((val) => ({ ...val, [name]: value }));
  };
  function CreateFile(e) {
    e.preventDefault();
    var bodyFormData = new FormData();
    bodyFormData.append("number", String(inputs.number ?? "").trim());
    bodyFormData.append("entity", inputs.entity);
    bodyFormData.append("reason", inputs.reason);
    bodyFormData.append("is_open", true);
    bodyFormData.append("open_date", inputs.open_date);
    bodyFormData.append("customer", inputs.customer);
    bodyFormData.append("created_by", localStorage.userId);
    if (inputs.founder) {
      bodyFormData.append("founder", inputs.founder);
    }
    if (Array.isArray(inputs.freelance) && inputs.freelance.length > 0) {
      inputs.freelance.forEach((free) => {
        bodyFormData.append("freelancers", free.value);
      });
    }
    if (Array.isArray(inputs.beneficiaries) && inputs.beneficiaries.length > 0) {
      inputs.beneficiaries.forEach((benef) => {
        bodyFormData.append("beneficiaries", benef.value);
      });
    }
    setIsCreating(true);
    instance
      .post(`files/`, bodyFormData)
      .then((res) => {
        if (res.data) {
          setIsCreating(false);
          setmodalDialogFileCreate(false);
          dispatch(addFilesOpen({ id: res.data.id, number: res.data.number }));
          history.push(`/Expediente/${res.data.id}`);
        }
      })
      .catch((e) => {
        setIsCreating(false);
        const data = e?.response?.data;
        const messages = data
          ? typeof data === "string"
            ? [data]
            : Object.values(data).flatMap((v) => (Array.isArray(v) ? v : [String(v)]))
          : ["Lo sentimos, algo falló. Vuelve a intentarlo."];
        setmodalDialogAlert(true);
        setmodalDialogAlertError(messages);
      });
  }
  function AsignarExpediente(idfile) {
    if (isAssigning) {
      return;
    }
    setIsAssigning(true);
    var bodyFormData = new FormData();
    bodyFormData.append("receiver", PersonaAsignar);
    bodyFormData.append("comment", ComentarioAsignar);
    instance
      .post(`files/${idfile}/assign`, bodyFormData)
      .then((res) => {
        if (res.status === 201) {
          setmodalAsignment(false);
          setPersonaAsignar("");
          setComentarioAsignar("");
          addNotification(
            "custom",
            "Success",
            "Expediente Asignado",
            "bottom-center",
            true
          );
        }
      })
      .catch((e) => {
        console.log("error", e);
        setmodalDialogAlert(true);
        setmodalDialogAlertError(e?.response?.data?.detail);
      })
      .finally(() => {
        setIsAssigning(false);
      });
  }

  const dispatch = useDispatch();
  const state = useSelector((state) => state, shallowEqual);
  const {
    // filesLoadedTest,
    filesLoaded,
    filesopen,
    users,
    Entities,
    personsCustomers,
    paginaFiles,
  } = state.counterSlice;
  useEffect(() => {
    if (localStorage.ExpedienteAsignado) {
      localStorage.removeItem("ExpedienteAsignado");
      addNotification(
        "custom",
        "Success",
        "Expediente Asignado",
        "bottom-center",
        true
      );
    }
  }, [localStorage.ExpedienteAsignado]);
  useEffect(() => {
    dispatch(getFiles(null, true));

    dispatch(getUsers());
    dispatch(getEntities());
    dispatch(getPersonsAssignments());
    instance
      .get(`files/reasons`)
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        var reason_all = data.map((val) => ({
          value: val,
          label: val,
        }));

        setreasons(reason_all);
      })
      .catch((e) => {
        console.log("error", e);
        // setmodalDialogAlert(true);
        // setmodalDialogAlertError(e?.response?.data?.detail);
      });
    instance
      .get(`people/?is_freelance=true`)
      .then((res) => {
        const data = Array.isArray(res?.data?.results)
          ? res.data.results
          : Array.isArray(res?.data)
          ? res.data
          : [];
        setPreloadedFreelancers(data);
      })
      .catch((e) => console.warn("Error preload freelancers", e.response));
  }, []);

  useEffect(() => {
    for (let i of filesopen) {
      dispatch(addFilesOpen(i));
    }
    setActiveTab(0);
  }, [filesopen]);

  useEffect(() => {
    setIsLoadingList(false);
  }, [filesLoaded]);

  function addNotification(
    notificationType,
    notificationTitle,
    notificationMessage,
    notificationPosition,
    notificationContent
  ) {
    const profilePic = localStorage.profile_pic;
    const profileImageSrc = profilePic
      ? profilePic.startsWith("http")
        ? profilePic
        : `${AxiosURLImage}${profilePic}`
      : imagenProfile;
    if (notificationContent) {
      notificationContent = (
        <div className="d-flex align-items-center bg-gray-100 rounded p-2 text-black w-100">
          <img src={profileImageSrc} width="52" alt="" className="rounded" />
          <div className="flex-1 " style={{ textAlign: "center" }}>
            {/* <h6 className="mb-1">Christopher Struth</h6> */}
            <p className="mb-0">{notificationMessage}</p>
          </div>
          <div
            className="h-100 d-flex align-items-center"
            style={{ borderLeft: "1px solid gray", padding: "2% 5%" }}
          >
            Cerrar
          </div>
        </div>
      );
    }
    Store.addNotification({
      title: notificationTitle,
      message: notificationMessage,
      type: notificationType,
      insert: "top",
      container: notificationPosition,
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: { duration: 2000 },
      dismissable: { click: true },
      content: notificationContent,
    });
  }

  //  const data = filesLoadedTest.length>0 ? filesLoadedTest[0].results:filesLoadedTest;
  const data = filesLoaded;
  const sortees = React.useMemo(
    () => [
      {
        id: "id",
        desc: false,
      },
    ],
    []
  );

  const columns = React.useMemo(
    () => [
      {
        Header: "#Expediente",
        accessor: "number",
        sortable: true,
      },
      {
        Header: "Consulta",
        accessor: "reason",
        sortable: true,
      },
      {
        Header: "Cliente",
        accessor: "customer",
        sortable: true,
      },
      {
        Header: "Entidad",
        accessor: "entity",
        sortable: true,
      },

      {
        Header: "Estado",
        accessor: "status",
        sortable: true,
      },
      {
        Header: "Freelance",
        accessor: "freelance",
        sortable: true,
      },
      {
        Header: "Modificado",
        accessor: "updated_at",
        sortable: true,
      },
      {
        Header: "Responsable",
        accessor: "responsible",
        sortable: true,
      },

      {
        Header: "Acciones",
        accessor: "Acciones",
        sortable: false,
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize, sortBy },
  } = useTable(
    {
      columns,
      data,
      manualSortBy: true,
      autoResetSortBy: false,
      initialState: { sortBy: sortees, pageIndex: initialPageIndex },
    },
    useSortBy,
    usePagination
  );

  function pdfdownload(current) {
    const doc = new jsPDF();
    autoTable(doc, { html: current });
    doc.save("table.pdf");
  }
  const handlePrint = useReactToPrint({
    pageStyle: "@page {size:auto;margin-bottom: 20mm }",
    content: () => {
      const tableStat = tableRef.current.cloneNode(true);
      const PrintElem = document.createElement("div");
      PrintElem.setAttribute("class", "containerPrint");
      const header =
        `<div class="page-header"><h1>Expedientes</div></h1>` +
        `<img src="https://siep.restrepofajardo.com/img/logo.png" alt="" class="watermark"/>` +
        `<div class="page-footer"><span>Impreso por: ${
          localStorage.full_name
        }</span><span>Fecha de Impresión: ${Moment().format(
          "D [de] MMMM [del] YYYY, h:mm a"
        )}</span></div>`;
      PrintElem.innerHTML = header;
      PrintElem.appendChild(tableStat);
      return PrintElem;
    },
  });
  function borrar(e) {
    dispatch(removeFilesOpen(e));
  }
  useEffect(() => {
    const counter = 100;
    let other = (pageIndex + 1) * pageSize;
    // if (filesLoadedTest.length>0 && filesLoadedTest[0].results.length / pageSize - 1 <= pageIndex + 1) {
    if (filesLoaded.length / pageSize - 1 <= pageIndex + 1) {
      if (
        (other % counter >= counter - pageSize && paginaFiles[1]) ||
        (other % counter == 0 && pageSize == 50)
      ) {
        setIsLoadingList(true) || dispatch(getFilesFromUrl(paginaFiles[1]));
      }
    }
    setinitialPageIndex(pageIndex);
  }, [pageIndex]);
  useEffect(() => {
    fakeApi(inputs.textSearch);
  }, [inputs["entityFilter"], inputs["estatusFilter"], inputs["endDate"]]);

  useEffect(() => {
    if (sortBy && sortBy.length > 0) {
      const { id, desc } = sortBy[0];
      const ord = desc ? `-${id}` : `${id}`;
      setServerOrdering(ord);
      fakeApi(inputs.textSearch, serverPageSize, ord);
    }
  }, [sortBy]);
  const fakeApi = (e, pageSizeOverride, orderingOverride, freelanceOnlyOverride) => {
    const ps = pageSizeOverride !== undefined ? pageSizeOverride : serverPageSize;
    const ord = orderingOverride !== undefined ? orderingOverride : serverOrdering;
    const freelanceOnly = freelanceOnlyOverride !== undefined
      ? freelanceOnlyOverride
      : inputs.freelanceOnly;
    const freelancerId = freelanceOnly
      ? localStorage.personId || localStorage.userId
      : null;
    let range = inputs?.startDate + "," + inputs?.endDate;
    setIsLoadingList(true);

    if (typeof inputs?.endDate === "string") {
      dispatch(
        getFilesSearch(
          e,
          true,
          inputs?.entityFilter?.value,
          inputs?.estatusFilter?.value,
          range,
          ps,
          ord,
          freelancerId
        )
      );
    } else {
      dispatch(
        getFilesSearch(
          e,
          true,
          inputs?.entityFilter?.value,
          inputs?.estatusFilter?.value,
          null,
          ps,
          ord,
          freelancerId
        )
      );
    }
    setinitialPageIndex(0);
    setCurrentPage(1);
  };
  const inputChanged = (e) => {
    clearTimeout(timer);

    const newTimer = setTimeout(() => {
      fakeApi(e.target.value);
      setInputs((val) => ({
        ...val,
        ["textSearch"]: e.target.value,
      }));
    }, 500);

    setTimer(newTimer);
  };
  const [activeTab, setActiveTab] = useState(filesopen ? filesopen.length : 0);
  const onTabClick = (e, index) => {
    setActiveTab(index);
  };

  const handleDateApplyEvent = (event, picker) => {
    let startDate = picker.startDate;
    let endDate = picker.endDate;

    setInputs((val) => ({
      ...val,
      startDate: startDate.format("YYYY-MM-DD"),
      endDate: endDate.format("YYYY-MM-DD"),
    }));
  };

  const opciones = {
    locale: {
      applyLabel: "Aplicar",
      cancelLabel: "Cancelar",
    },
  };

  const getPersonFullName = (person) => {
    if (!person) {
      return "";
    }
    if (person.full_name) {
      return person.full_name;
    }
    return `${person.first_name || ""} ${person.last_name || ""}`.trim();
  };

  const normalizeFreelancers = (freelanceValue) => {
    if (Array.isArray(freelanceValue)) {
      return freelanceValue;
    }
    return freelanceValue ? [freelanceValue] : [];
  };

  const renderFreelancers = (freelanceValue) => {
    const freelancers = normalizeFreelancers(freelanceValue);
    const canViewFreelancers =
      successPermissions("full_access_people", "can_view_freelancers") !=
      "d-none";

    if (!freelancers.length) {
      return "-";
    }

    const firstFreelancer = freelancers[0];
    const firstFreelancerName = getPersonFullName(firstFreelancer) || "-";
    const firstFreelancerNode =
      canViewFreelancers && firstFreelancer?.id ? (
        <Link to={`/Freelancer/${firstFreelancer.id}`}>{firstFreelancerName}</Link>
      ) : (
        firstFreelancerName
      );

    if (freelancers.length === 1) {
      return firstFreelancerNode;
    }

    return (
      <span className="d-inline-flex align-items-center">
        <span>{firstFreelancerNode}</span>
        <Tooltip
          prefixCls="rc-slider-tooltip"
          overlay={
            <span>
              <strong>Freelancers</strong>
              <br />
              {freelancers.map((person, index) => (
                <React.Fragment key={person?.id || `freelancer-tooltip-${index}`}>
                  {getPersonFullName(person) || "-"}
                  {index < freelancers.length - 1 ? <br /> : null}
                </React.Fragment>
              ))}
            </span>
          }
          placement="bottom"
        >
          <i
            style={{ color: "var(--app-theme)", cursor: "pointer" }}
            className="far fa-lg fa-fw ms-1 fa-eye"
          ></i>
        </Tooltip>
      </span>
    );
  };

  return (
    <div>
      <ol className="breadcrumb float-xl-end">
        <li className="breadcrumb-item">
          <Link to="/table/data">Home</Link>
        </li>
        <li className="breadcrumb-item">
          <Link to="/Expedientes">Expedientes</Link>
        </li>
        {/* <li className="breadcrumb-item active">Data Tables</li> */}
      </ol>
      <h1 className="page-header">
        Expedientes <small></small>
      </h1>
      <Panel>
        <PanelHeader>
          {filesopen && filesopen.length > 0
            ? "Expedientes abiertos :"
            : "Expedientes "}
        </PanelHeader>
        <div className="ExpedientesOpened">
          {filesopen && filesopen.length > 0 ? (
            <Tabs
              activeTab={activeTab}
              onTabClick={onTabClick}
              hideNavBtnsOnMobile={false}
            >
              {/* generating an array to loop through it  */}
              {filesopen.sort(useCompareId).map((e, i) => (
                <Tab key={i}>
                  <Link to={`/Expediente/${e.id}`}>Exp {e.number} </Link>
                  <i
                    className="far fa-lg fa-fw me-10px fa-circle-xmark ps-2"
                    style={{ color: "#ffff" }}
                    onClick={() => borrar(e.id)}
                  ></i>
                </Tab>
              ))}
            </Tabs>
          ) : null}
        </div>
        <PanelBody>
          <div className="invoice-company">
            <span className="float-end hidden-print d-flex">
              {successPermissions("can_write_files") == "d-none" ? null : (
                <button
                  onClick={() => setmodalDialogFileCreate(true)}
                  className="btn btn-warning mb-10px me-1"
                  title="Crear expediente"
                >
                  <i className="fa fa-folder-plus fa-fw"></i>
                  <span className="d-none d-md-inline ms-1">Crear expediente</span>
                </button>
              )}
              {successPermissions("can_export_open_excel_files") ==
              "d-none" ? null : (
                <>
                  {" "}
                  <button
                    onClick={() => pdfdownload(tableRef.current)}
                    className="btn btn-sm btn-white mb-10px me-1 d-none d-sm-block"
                  >
                    <i className="fa fa-file-pdf t-plus-1 text-blue fa-fw fa-lg"></i>{" "}
                  </button>
                  <button
                    onClick={onDownload}
                    className="btn btn-sm btn-white mb-10px me-1 "
                  >
                    <i className="fa fa-file-excel t-plus-1 text-green fa-fw fa-lg"></i>
                  </button>
                  <button
                    onClick={handlePrint}
                    className="btn btn-sm btn-white mb-10px me-1 d-none d-sm-block"
                  >
                    <i className="fa fa-print t-plus-1 fa-fw fa-lg"></i>
                  </button>
                </>
              )}
            </span>
            <div className="d-block d-md-flex align-items-center">
              <label className="d-none d-xl-block form-label pe-2 mb-0">
                Expedientes por página:
              </label>
              <div className="d-none d-xl-block">
                <select
                  className="form-select"
                  value={pageSize}
                  onChange={(e) => {
                    const newSize = Number(e.target.value);
                    setPageSize(newSize);
                    setServerPageSize(newSize);
                    fakeApi(inputs.textSearch, newSize, serverOrdering);
                  }}
                >
                  {[10, 20, 30, 40, 50].map((pageSize) => (
                    <option key={pageSize} value={pageSize}>
                      Mostrar {pageSize}
                    </option>
                  ))}
                </select>
              </div>
              <div className="d-flex pe-2 pe-md-0">
                <form action="" method="POST" name="search_form">
                  <div className="form-group position-relative mx-3 width_seach_type w-sm-50 pe-4 d-flex">
                    {" "}
                    <button
                      className="btn btn-search position-absolute border-0"
                      disabled={true}
                    >
                      <i className="fa fa-search me-20px icon-search-action"></i>
                    </button>{" "}
                    <input
                      type="text"
                      id="inputTextSearch"
                      className="form-control px-5"
                      placeholder="Buscar Expediente ..."
                      onChange={inputChanged}
                    />
                  </div>
                </form>
                <UncontrolledButtonDropdown
                  isOpen={inputs.closeFilters}
                  toggle={() => {
                    setInputs((val) => ({
                      ...val,
                      ["closeFilters"]: true,
                    }));
                  }}
                  direction="down"
                  className="  btn-filter"
                >
                  <DropdownToggle
                    color="default"
                    className="dropdown-toggle"
                    style={{
                      borderColor: "#adb5bd",
                      color: "#ffff",
                      background: "transparent",
                    }}
                  >
                    <i className="fa fa-list text-gray fa-fw fa-lg "></i>
                  </DropdownToggle>
                  <DropdownMenu>
                    <div style={{ padding: "0.625rem" }}>
                      <Select
                        style={{ zIndex: "10" }}
                        className="widthInput w-md-200px   m-1"
                        options={Entities.map((entitie) => ({
                          value: entitie.id,
                          label: entitie.name,
                        }))}
                        // isMulti
                        placeholder="Entidad"
                        value={inputs.entityFilter}
                        name="entity"
                        onChange={(e) =>
                          setInputs((val) => ({
                            ...val,
                            ["entityFilter"]: e,
                          }))
                        }
                      />
                    </div>

                    <DropdownItem divider></DropdownItem>

                    <div style={{ padding: "0.625rem" }}>
                      <Select
                        className="widthInput w-md-200px m-1"
                        options={optionsStatus}
                        placeholder="Estado"
                        value={
                          inputs?.estatusFilter ? [inputs.estatusFilter] : false
                        }
                        name="Estado"
                        onChange={(e) =>
                          setInputs((val) => ({
                            ...val,
                            ["estatusFilter"]: e,
                          }))
                        }
                      />
                    </div>
                    <DropdownItem divider></DropdownItem>

                    {localStorage?.is_freelance === "true" && (
                      <>
                        <div className="form-check mx-3 my-2">
                          <input
                            id="freelanceOnlyFilter"
                            type="checkbox"
                            className="form-check-input"
                            checked={inputs.freelanceOnly}
                            onChange={(event) => {
                              const checked = event.target.checked;
                              setInputs((val) => ({
                                ...val,
                                freelanceOnly: checked,
                              }));
                              fakeApi(
                                inputs.textSearch,
                                serverPageSize,
                                serverOrdering,
                                checked
                              );
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="freelanceOnlyFilter"
                          >
                            Ver solamente mis expedientes como freelance
                          </label>
                        </div>
                        <DropdownItem divider></DropdownItem>
                      </>
                    )}

                    <div
                      style={{ padding: "0.625rem" }}
                      className="calendarExpedientes"
                    >
                      <DateRangePicker
                        startDate={inputs.startDate}
                        endDate={inputs.endDate}
                        onApply={handleDateApplyEvent}
                        initialSettings={opciones}
                      >
                        <input
                          type="text"
                          className="form-control  col-4 text-center"
                        />
                      </DateRangePicker>
                    </div>
                    <div className="d-flex justify-content-end mx-2 my-1">
                      <button
                        onClick={() => {
                          setInputs((val) => ({
                            ...val,
                            ["estatusFilter"]: null,
                            ["entityFilter"]: null,
                            freelanceOnly: false,
                            startDate: Moment().subtract(7, "days"),
                            endDate: Moment(),
                          }));
                          fakeApi(
                            inputs.textSearch,
                            serverPageSize,
                            serverOrdering,
                            false
                          );
                        }}
                        className=" btn btn-sm btn-danger me-1"
                      >
                        Limpiar
                      </button>
                      <button
                        onClick={() =>
                          setInputs((val) => ({
                            ...val,
                            ["closeFilters"]: false,
                          }))
                        }
                        className=" btn btn-sm btn-warning  me-1"
                      >
                        Salir
                      </button>
                    </div>
                  </DropdownMenu>
                </UncontrolledButtonDropdown>
              </div>
            </div>
          </div>
        </PanelBody>
        <div className="table-responsive position-relative">
          <ReactNotifications />
          {isLoadingList ? (
            <div
              className="d-flex justify-content-center align-items-center py-5"
              style={{
                position: filesLoaded && filesLoaded.length > 0 ? "absolute" : "static",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor:
                  filesLoaded && filesLoaded.length > 0
                    ? "rgba(255,255,255,0.6)"
                    : "transparent",
                zIndex: 5,
              }}
            >
              <div className="fa-3x">
                <i className="fas fa-cog fa-spin"></i>
              </div>
            </div>
          ) : null}
          {filesLoaded && filesLoaded.length === 0 && !isLoadingList ? (
            <div className="fw-bold text-center mb-3 py-4">
              No se encontraron expedientes
            </div>
          ) : filesLoaded && typeof filesLoaded[0] === "string" ? (
            <div className="fw-bold text-center mb-3">{filesLoaded[0]}</div>
          ) : (
            <>
              <table
                ref={tableRef}
                style={{ background: "var(--app-sidebar-bg)" }}
                className="table table-panel table-bordered mb-0 "
                {...getTableProps()}
              >
                <thead>
                  {headerGroups.map((headerGroup) => {
                    const { key: headerGroupKey, ...headerGroupProps } =
                      headerGroup.getHeaderGroupProps();
                    return (
                      <tr
                        key={headerGroupKey}
                        {...headerGroupProps}
                        className="nav-Tables-head"
                      >
                        {headerGroup.headers.map((column) => {
                          const { key: columnKey, ...columnProps } =
                            column.getHeaderProps(column.getSortByToggleProps());
                          return (
                            <th
                              key={columnKey}
                              className="text-center"
                              {...columnProps}
                            >
                            <div
                              className="d-flex align-items-center "
                              style={{
                                minWidth: "100px",
                                justifyContent: "center",
                              }}
                            >
                              <span>{column.render("Header")}</span>
                              <span className="">
                                {column.sortable ? (
                                  column.isSorted ? (
                                    column.isSortedDesc ? (
                                      <i className="fa fa-sort-down fa-fw fs-14px text-blue"></i>
                                    ) : (
                                      <i className="fa fa-sort-up fa-fw fs-14px text-blue"></i>
                                    )
                                  ) : (
                                    <i className="fa fa-sort fa-fw fs-14px opacity-3"></i>
                                  )
                                ) : (
                                  ""
                                )}
                              </span>
                            </div>
                            </th>
                          );
                        })}
                      </tr>
                    );
                  })}
                </thead>

                <tbody {...getTableBodyProps()}>
                  {page.map((row, i) => {
                    prepareRow(row);
                    const { key: rowKey, ...rowProps } = row.getRowProps();
                    return (
                      <tr key={rowKey} {...rowProps} className="colorRow-Tables">
                        {row.cells.map((cell, index) => {
                          const { key: cellKey, ...cellProps } =
                            cell.getCellProps();
                          return (
                            <td key={cellKey} {...cellProps}>
                              {cell.column.Header == "#Expediente" ? (
                                <>
                                  {cell.render("Cell")}{" "}
                                  <Tooltip
                                    prefixCls="rc-slider-tooltip"
                                    overlay={
                                      <span
                                        type="text"
                                        id="pelanga"
                                        title={"salamandra"}
                                        style={{
                                          color: "white",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <strong>Fecha de apertura:</strong>{" "}
                                        <br />
                                        <span
                                          id={"Fecha_Apertura" + row.id}
                                          title={formatExpedienteDate(
                                            row.original["open_date"]
                                          )}
                                        >
                                          {formatExpedienteDate(
                                            row.original["open_date"]
                                          )}{" "}
                                        </span>
                                        <span
                                          onClick={() =>
                                            CopyRight(
                                              "Fecha_Apertura" + row.id
                                            ) ||
                                            addNotification(
                                              "default",
                                              "",
                                              "Copiado",
                                              "bottom-center"
                                            )
                                          }
                                          style={{
                                            textDecorationLine: "underline",
                                            color: "#348fe2",
                                          }}
                                        >
                                          Copy
                                        </span>
                                      </span>
                                    }
                                    placement="bottom"
                                    key={index}
                                  >
                                    <i
                                      style={{
                                        color: "var(--app-theme)",
                                        cursor: "pointer",
                                      }}
                                      className="far fa-lg fa-fw me-10px fa-eye"
                                    ></i>
                                  </Tooltip>
                                </>
                              ) : cell.column.Header == "Acciones" ? (
                                <div
                                  className="vertical-middle"
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  {(() => {
                                    const expedienteStatus = Number(
                                      row.original["status"]
                                    );
                                    const isAssignButtonDisabled =
                                      expedienteStatus === 20 ||
                                      expedienteStatus === 30 ||
                                      !canAssignExpediente(
                                        row.original["responsible"]?.id
                                      );
                                    return (
                                      <>
                                  <Link
                                    to={`/Expediente/${row.original["id"]}`}
                                    onClick={() => {
                                      dispatch(
                                        addFilesOpen({
                                          id: row.original["id"],
                                          number: row.original["number"],
                                        })
                                      );
                                    }}
                                    className={`btn btn-sm btn-green  me-1 p-auto`}
                                  >
                                    <i className="fab fa-lg fa-fw fs-14px fa-sistrix text-white"></i>
                                  </Link>

                                  <button
                                    onClick={() =>
                                      setmodalAsignment(true) ||
                                      setIdSelected(row.original["id"])
                                    }
                                    className={`${successPermissions(
                                      "can_create_file_assignment"
                                    )} btn btn-sm btn-success p-auto`}
                                    disabled={isAssignButtonDisabled}
                                    title={
                                      !canAssignExpediente(
                                        row.original["responsible"]?.id
                                      )
                                        ? "Solo el responsable, líder de equipo o superusuario puede asignar"
                                        : "Asignar expediente"
                                    }
                                  >
                                    <i className="fas fa-lg fa-fw fs-14px fa-share-from-square"></i>
                                    {/* <i className="fas fa-lg fa-fw fs-14px fa-square-up-right"></i> */}
                                  </button>
                                      </>
                                    );
                                  })()}
                                </div>
                              ) : cell.column.Header == "Estado" ? (
                                <span
                                  className={classesStatus(
                                    row.original["status"]
                                  )}
                                >
                                  <i className="fa fa-circle fs-9px fa-fw me-5px"></i>{" "}
                                  {/* {cell.render("Cell")} */}{" "}
                                  {status(row.original["status"])}
                                </span>
                              ) : cell.column.Header == "Modificado" ? (
                                formatExpedienteDate(row.original["updated_at"])
                              ) : cell.column.Header == "Consulta" ? (
                                row.original["reason"] || "-"
                              ) : cell.column.Header == "Cliente" ? (
                                row.original["customer"]?.full_name
                              ) : cell.column.Header == "Entidad" ? (
                                row.original["entity"]?.name
                              ) : cell.column.Header == "Freelance" ? (
                                renderFreelancers(
                                  row.original["freelancers"] ||
                                    row.original["freelance"]
                                )
                              ) : cell.column.Header == "Responsable" ? (
                                row.original["responsible"]?.full_name
                              ) : (
                                cell.render("Cell")
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <PanelBody>
                <div className="d-flex align-items-center justify-content-center">
                  <div className="me-1 d-none d-sm-block">Ir a página:</div>
                  <div className="w-50px mx-2 me-auto d-none d-sm-block">
                    <input
                      className="form-control px-2"
                      type="number"
                      value={currentPage}
                      onChange={(e) => {
                        const target = e.target.value ? Number(e.target.value) : 1;
                        setCurrentPage(target);
                      }}
                    />
                  </div>
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        className="page-link"
                        onClick={() => { if (paginaFiles[0]) { setIsLoadingList(true) || dispatch(getFilesFromUrl(paginaFiles[0])); setCurrentPage(1); } }}
                        disabled={!paginaFiles[0]}
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        className="page-link"
                        onClick={() => { if (paginaFiles[0]) { setIsLoadingList(true) || dispatch(getFilesFromUrl(paginaFiles[0])); setCurrentPage(p => p - 1); } }}
                        disabled={!paginaFiles[0]}
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Pág.{" "}
                        <strong>
                          {currentPage} de{" "}
                          {paginaFiles[2]
                            ? Math.ceil(paginaFiles[2] / serverPageSize)
                            : 1}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        className="page-link"
                        onClick={() => { if (paginaFiles[1]) { setIsLoadingList(true) || dispatch(getFilesFromUrl(paginaFiles[1])); setCurrentPage(p => p + 1); } }}
                        disabled={!paginaFiles[1]}
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        className="page-link"
                        onClick={() => { if (paginaFiles[1]) { setIsLoadingList(true) || dispatch(getFilesFromUrl(paginaFiles[1])); setCurrentPage(Math.ceil(paginaFiles[2] / serverPageSize)); } }}
                        disabled={!paginaFiles[1]}
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                </div>
              </PanelBody>
              {paginaFiles[2] ? (
                <div className="hljs-wrapper">
                  <div className="p-3">
                    {" "}
                    <span style={{ color: "#4a9be5", fontSize: "12px" }}>
                      {paginaFiles[2]}
                    </span>{" "}
                    resultados
                  </div>
                </div>
              ) : null}
            </>
          )}
        </div>{" "}
        <Modal isOpen={modalDialogFileCreate}>
          <ModalHeader
            close={
              <button
                className="btn-close"
                onClick={() => setmodalDialogFileCreate(!modalDialogFileCreate)}
              ></button>
            }
          >
            Expediente
          </ModalHeader>
          <form onSubmit={CreateFile}>
            <ModalBody className="m-auto w-100" style={{ overflowY: "auto" }}>
              <tr className="my-1 d-flex" style={{ justifyContent: "center" }}>
                <td className="d-flex column-create-inputs flex-md-row">
                  <div>
                    <td className="field">No de expediente</td>{" "}
                    <input
                      required
                      name="number"
                      style={{
                        border: "1px solid hsl(0, 0%, 80%)",
                        borderRadius: "4px",
                        padding: "10px",
                      }}
                      onChange={handleChange}
                      className="widthInput w-md-200px py-2  m-1"
                      type="text"
                    ></input>
                  </div>
                  <div>
                    <td className="field">Fecha de apertura</td>
                    <input
                      name="open_date"
                      style={{
                        border: "1px solid hsl(0, 0%, 80%)",
                        borderRadius: "4px",
                        paddingTop: "0.3rem",
                        paddingBottom: "0.3rem",
                      }}
                      onChange={handleChange}
                      defaultValue={toDay}
                      className="form-control widthInput w-md-200px p-2  m-1"
                      type="date"
                    ></input>
                  </div>
                </td>
              </tr>
              <tr className="my-1 d-flex" style={{ justifyContent: "center" }}>
                <td className="d-flex column-create-inputs flex-md-row">
                  <div>
                    <td className="field">Tipo Consulta</td>{" "}
                    <CreatableSelect
                      className="widthInput w-md-200px   m-1"
                      placeholder="Selecciona"
                      isClearable
                      onChange={(newValue) => {
                        setvalue_reason(newValue);
                        setInputs((val) => ({
                          ...val,
                          ["reason"]: newValue.value,
                        }));
                      }}
                      options={reasons}
                      value={value_reason}
                    />
                  </div>
                  <div>
                    <td className="field">Entidad</td>
                    <Select
                      className="widthInput w-md-200px   m-1"
                      options={Entities.map((entitie) => ({
                        value: entitie.id,
                        label: entitie.name,
                      }))}
                      placeholder="Selecciona"
                      defaultValue={false}
                      name="entity"
                      onChange={(e) =>
                        setInputs((val) => ({
                          ...val,
                          ["entity"]: e.value,
                        }))
                      }
                    />
                  </div>
                </td>
              </tr>
              <tr className="my-1 d-flex" style={{ justifyContent: "center" }}>
                <td className="d-flex column-create-inputs flex-md-row">
                  <div>
                    <td className="field">Cliente</td>{" "}
                    <Select
                      className="widthInput w-md-200px   m-1"
                      isLoading={inputs.isLoading}
                      onInputChange={(e) => {
                        setInputs((val) => ({
                          ...val,
                          ["isLoading"]: true,
                        }));
                        setTimeout(() => {
                          setInputs((val) => ({
                            ...val,
                            ["isLoading"]: false,
                          }));
                        }, 700);
                        if (e.length > 1) {
                          dispatch(getPersonsCustomer(e, "&is_customer=true"));
                        }
                      }}
                      options={
                        personsCustomers &&
                        personsCustomers.map((personCus) => ({
                          value: personCus.id,
                          label:
                            personCus.first_name + " " + personCus.last_name,
                        }))
                      }
                      placeholder="Selecciona"
                      defaultValue={false}
                      name="customer"
                      onChange={(e) => {
                        setInputs((val) => ({
                          ...val,
                          ["customer"]: e.value,
                        }));
                      }}
                    />
                  </div>
                  <div>
                    <td className="field">Causante</td>
                    <Select
                      className="widthInput w-md-200px   m-1"
                      isLoading={inputs.isLoadingCausante}
                      onInputChange={(e) => {
                        setInputs((val) => ({
                          ...val,
                          ["isLoadingCausante"]: true,
                        }));
                        setTimeout(() => {
                          setInputs((val) => ({
                            ...val,
                            ["isLoadingCausante"]: false,
                          }));
                        }, 700);
                        if (e.length > 1) {
                          dispatch(getPersonsCustomer(e));
                        }
                      }}
                      options={
                        personsCustomers &&
                        personsCustomers.map((personCus) => ({
                          value: personCus.id,
                          label:
                            personCus.first_name + " " + personCus.last_name,
                        }))
                      }
                      placeholder="Selecciona"
                      defaultValue={false}
                      name="founder"
                      onChange={(e) => {
                        setInputs((val) => ({
                          ...val,
                          ["founder"]: e.value,
                        }));
                      }}
                    />
                  </div>
                </td>
              </tr>
              <tr className="my-1 d-flex" style={{ justifyContent: "center" }}>
                <td className="d-flex column-create-inputs flex-md-row">
                  <div>
                    <td className="field">Freelance</td>{" "}
                    <Select
                      id="clientec"
                      className="widthInput w-md-200px   m-1"
                      isLoading={inputs.isLoadingFree}
                      onInputChange={(e) => {
                        setInputs((val) => ({
                          ...val,
                          ["inputFreelance"]: e || "",
                        }));
                        setInputs((val) => ({
                          ...val,
                          ["isLoadingFree"]: true,
                        }));
                        setTimeout(() => {
                          setInputs((val) => ({
                            ...val,
                            ["isLoadingFree"]: false,
                          }));
                        }, 700);
                        if (e.length > 1) {
                          dispatch(getPersonsCustomer(e, "&is_freelance=true"));
                        }
                      }}
                      options={
                        (inputs.inputFreelance || "").length > 1
                          ? personsCustomers &&
                            personsCustomers.map((personCus) => ({
                              value: personCus.id,
                              label:
                                personCus.first_name +
                                " " +
                                personCus.last_name,
                            }))
                          : preloadedFreelancers.map((personCus) => ({
                              value: personCus.id,
                              label:
                                personCus.first_name +
                                " " +
                                personCus.last_name,
                            }))
                      }
                      placeholder="Selecciona"
                      defaultValue={false}
                      isMulti
                      value={inputs.freelance || []}
                      name="freelance"
                      onChange={(e) => {
                        setInputs((val) => ({
                          ...val,
                          ["freelance"]: e || [],
                        }));
                      }}
                    />
                  </div>
                  <div>
                    <td className="field">Beneficiarios</td>
                    <Select
                      className="widthInput w-md-200px   m-1"
                      options={
                        personsCustomers.length > 0 &&
                        personsCustomers.map((personCus) => ({
                          value: personCus.id,
                          label:
                            personCus.first_name + " " + personCus.last_name,
                        }))
                      }
                      placeholder="Selecciona"
                      isLoading={inputs.isLoadingBen}
                      onInputChange={(e) => {
                        setInputs((val) => ({
                          ...val,
                          ["isLoadingBen"]: true,
                        }));
                        setTimeout(() => {
                          setInputs((val) => ({
                            ...val,
                            ["isLoadingBen"]: false,
                          }));
                        }, 700);
                        if (e.length > 1) {
                          getPersonsCustomer(e);
                        }
                      }}
                      defaultValue={false}
                      isMulti
                      name="Beneficiarios"
                      onChange={(e) =>
                        setInputs((val) => ({
                          ...val,
                          ["beneficiaries"]: e,
                        }))
                      }
                    />
                  </div>
                </td>
              </tr>
              <tr className="my-1 d-flex" style={{ justifyContent: "center" }}>
                <td className="d-flex column-create-inputs flex-md-row">
                  <div>
                    <td className="field">Creado por</td>
                    <input
                      readOnly
                      value={localStorage.full_name || ""}
                      style={{
                        border: "1px solid hsl(0, 0%, 80%)",
                        borderRadius: "4px",
                        padding: "10px",
                        backgroundColor: "#f8f9fa",
                      }}
                      className="widthInput w-md-200px py-2 m-1"
                      type="text"
                    />
                  </div>
                  <div className="widthInput w-md-200px   m-1"></div>
                </td>
              </tr>
              <br />
              <br />
            </ModalBody>
            <ModalFooter>
              <button
                className="btn btn-white"
                disabled={isCreating}
                onClick={() => setmodalDialogFileCreate(!modalDialogFileCreate)}
              >
                Cerrar
              </button>
              <button type="submit" className="btn btn-warning" disabled={isCreating}>
                {isCreating ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true" />
                    Creando...
                  </>
                ) : "Crear"}
              </button>
            </ModalFooter>
          </form>
        </Modal>
        <Modal
          isOpen={modalAsignment}
          toggle={() => {
            if (!isAssigning) {
              setmodalAsignment(false);
            }
          }}
        >
          <ModalHeader
            toggle={() => {
              if (!isAssigning) {
                setmodalAsignment(false);
              }
            }}
            close={
              <button
                className="btn-close"
                disabled={isAssigning}
                onClick={() => setmodalAsignment(false)}
              ></button>
            }
          >
            Asignar Expediente
          </ModalHeader>
          <ModalBody>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <div className="d-flex mx-auto" style={{ width: "80%" }}>
                <div className=" field m-auto ">Asignar a</div>
                <div>
                  <Select
                    className="w-300px m-auto"
                    options={users.map((person) => ({
                      label: person.first_name + " " + person.last_name,
                      value: person.id,
                    }))}
                    placeholder="Selecciona"
                    defaultValue={false}
                    name="Personas"
                    onChange={(e) => setPersonaAsignar(e.value)}
                  />
                </div>
              </div>

              <br />

              <div className="d-flex  mx-auto" style={{ width: "80%" }}>
                <div className="field m-auto">Comentario</div>
                <div>
                  <textarea
                    onChange={(e) => setComentarioAsignar(e.target.value)}
                    placeholder="Escribe tu comentario"
                    className="w-300px m-auto p-2"
                    style={{
                      borderColor: "hsl(0, 0%, 80%)",
                      borderRadius: "4px",
                    }}
                  ></textarea>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              className="btn btn-white"
              disabled={isAssigning}
              onClick={() => setmodalAsignment(false)}
            >
              Cerrar
            </button>
            <button
              onClick={() => AsignarExpediente(IdSelected)}
              className="btn btn-success"
              disabled={isAssigning}
            >
              {isAssigning ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Asignando
                </>
              ) : (
                "Asignar"
              )}
            </button>
          </ModalFooter>
        </Modal>
        {modalDialog ? (
          <SweetAlert
            danger
            showCancel
            confirmBtnText="Yes, delete it!"
            confirmBtnBsStyle="danger"
            cancelBtnBsStyle="default"
            title="Are you sure?"
            onConfirm={() => setmodalDialog(!modalDialog)}
            onCancel={() => setmodalDialog(!modalDialog)}
          >
            You will not be able to recover this imaginary file!
          </SweetAlert>
        ) : null}
        {/* <SweetAlert
            danger
            showCancel
            confirmBtnText="Yes, delete it!"
            confirmBtnBsStyle="danger"
            cancelBtnBsStyle="default"
            title="Are you sure?"
            onConfirm={() => setmodalDialog(!modalDialog)}
            onCancel={() => setmodalDialog(!modalDialog)}
          >
            You will not be able to recover this imaginary file!
          </SweetAlert> */}
        {/* <Modal
          isOpen={modalDialog}
          // toggle={() => this.toggleModal("modalDialog")}
        >
          <ModalHeader
            // toggle={() => this.toggleModal("modalDialog")}
            close={
              <button
                className="btn-close"
                onClick={() => setmodalDialog(!modalDialog)}
              ></button>
            }
          >
            Modal Dialog
          </ModalHeader>
          <ModalBody>
            <p>Modal body content here...</p>
          </ModalBody>
          <ModalFooter>
            <button
              className="btn btn-white"
              onClick={() => setmodalDialog(!modalDialog)}
            >
              Close
            </button>
            <button className="btn btn-success">Action</button>
          </ModalFooter>
        </Modal> */}
        <Modal isOpen={modalDialogAlert}>
          <ModalHeader
            close={
              <button
                className="btn-close"
                onClick={() => setmodalDialogAlert(!modalDialogAlert)}
              ></button>
            }
          >
            Algo ha ocurrido
          </ModalHeader>
          <ModalBody>
            <div className="alert alert-danger mb-0">
              <h5>
                <i className="fa fa-info-circle"></i> Algo salió mal
              </h5>
              {Array.isArray(modalDialogAlertError) ? (
                <ul className="mb-0 ps-3">
                  {modalDialogAlertError.map((msg, i) => (
                    <li key={i}>{msg}</li>
                  ))}
                </ul>
              ) : (
                <p className="mb-0">
                  {modalDialogAlertError || "Lo sentimos algo falló, vuelve a intentar en un momento."}
                </p>
              )}
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              className="btn btn-white"
              onClick={() => setmodalDialogAlert(!modalDialogAlert)}
            >
              Cerrar
            </button>
          </ModalFooter>
        </Modal>
      </Panel>
    </div>
  );
};

export default Expedientes;
